export const DESCRIPTIVE_REPORT_ERROR_MESSAGE = 'Failed to generate descriptive report';

export function requireDescriptiveReportText(text: string | null | undefined): string {
  const normalized = String(text ?? '').trim();
  if (!normalized) {
    throw new Error(DESCRIPTIVE_REPORT_ERROR_MESSAGE);
  }
  return normalized;
}
